import Css from "./style.module.scss";

import dropBox from "assets/dropBox.svg";

import Button from "nlib/ui/Button";
import DocumentFileTypes from "const/DocumentFileTypes";
import DropboxChooser from "react-dropbox-chooser";
import Environment from "utils/Environment";
import React, { useCallback } from "react";

const SERVICE_NAME = "Dropbox";

const FILE_DROP_MIME_TYPES = Object.values(DocumentFileTypes)
  .reduce((aggregator, { extensions, mimeType }) => [...aggregator, ...extensions, mimeType], []);

const DropBoxPicker = ({ onFilesPicked }) => {
  const { DROPBOX_APP_KEY } = Environment.getProcessEnvVars();

  const successCallback = useCallback((files) => {
    const result = files.map((file) => {
      const extension = `.${file.link.split(".").pop().toLowerCase()}`;

      const { mimeType } = Object.values(DocumentFileTypes).find(({ extensions }) => extensions.includes(extension));

      return { ...file, mimeType };
    });

    onFilesPicked(result);
  }, [onFilesPicked]);

  return (
    <DropboxChooser
      multiselect
      linkType="direct"
      appKey={DROPBOX_APP_KEY}
      success={successCallback}
      extensions={FILE_DROP_MIME_TYPES}>
      <Button className={Css.dropBoxPicker}>
        <img src={dropBox} alt={SERVICE_NAME} title={SERVICE_NAME} />
        <span>{SERVICE_NAME}</span>
      </Button>
    </DropboxChooser>
  );
};

export default React.memo(DropBoxPicker);
